import { meApi } from '@/api/endpoints/me';
import type { NotificationItem } from '../model/types';

// Адаптер нашего meApi.notifications() → NotificationItem[].
// Бек отдаёт только unread (через Notification::find()->me()->unreviewed()).
// id у нас не приходит — собираем синтетический ключ из created_at+index.
// desc ← message; date оставляем как есть (ISO 8601), форматирование — в UI.

export const getNotifications = async (): Promise<NotificationItem[]> => {
  const items = await meApi.notifications();
  return items.map((item, index) => ({
    id: `${item.created_at}-${index}`,
    date: item.created_at,
    title: item.title ?? '',
    desc: item.message,
    status: item.status,
  }));
};
